import React from 'react';
import { WrenchIcon } from 'lucide-react';
export function Problem() {
  return <section className="bg-white px-5 py-7" data-id="element-147" data-mp="2wfdit977eqyv">
      <div className="mx-auto max-w-[520px]" data-id="element-148" data-mp="2wfn96xw5v053">
        <h2 className="text-center font-display text-[21px] uppercase leading-[1.05] text-navy md:text-[24px]" data-id="element-149" data-mp="2roevhpnsssm4">
          Stop guessing what’s causing the diesel problem
        </h2>
        <p className="mt-3 text-[12px] leading-[1.6] text-ink" data-id="element-150" data-mp="2mnhh7o5wsipw">
          Hard start or no-start? Low power, excessive smoke or boost problems? Fuel pressure, injectors, turbo, sensors, DPF… Where do you test first?
          DIESEL DIAGNOSTIC PRO™ gives you an organized visual diagnostic system to help you move from symptom to possible cause with a clearer testing
          path. <strong className="font-bold text-navy" data-id="element-151" data-mp="23s0xf2cs4p75">Scan. Test. Isolate.</strong>
        </p>
        <div className="mt-4 rounded-[3px] border-l-[3px] border-gold bg-paper px-4 py-3" data-id="element-152" data-mp="6xnx0js0jc03">
          <h3 className="flex items-center gap-1.5 font-display text-[14px] uppercase leading-tight text-navy" data-id="element-153" data-mp="20ebvgbnpmi2">
            <WrenchIcon className="h-3.5 w-3.5 shrink-0 text-goldDark" aria-hidden="true" data-id="element-154" data-mp="149ilsrdsscmt" />
            Stop diagnosing every diesel fault from scratch
          </h3>
          <p className="mt-1.5 text-[11.5px] leading-[1.6] text-muted" data-id="element-155" data-mp="vb5jmy3nql1z">
            You already know diesel repair. The problem is wasting time jumping between possible causes without a clear diagnostic sequence. Open
            the system, identify the symptom and follow the relevant tests.{' '}
            <strong className="font-bold text-navy" data-id="element-156" data-mp="1s0wdqw81e679">Less guessing. More structured diagnosis.</strong>
          </p>
        </div>
      </div>
    </section>;
}